import React, {useEffect, useState} from 'react';
import MultiSearch from "./MultiSearch";
import {useAdvancedSearchBAMutation} from "../../core/api/bermuda-state-api";

export default function SearchBarBA() {
    return <MultiSearch useSearchHook={useAdvancedSearchBAMutation} />
}